import { ScorecardReport } from '../../components/ScorecardReport';

/**
 * The NOC scorecard — the NOC items in the scorecard library, with figures
 * from Autotask's alert tickets and Automate's agents
 * (api/src/lib/noc/nocScorecard.ts). The report itself is shared with the CS
 * page: components/ScorecardReport.tsx.
 */
export function NocScorecard() {
  return (
    <ScorecardReport
      path="/noc/scorecard"
      team="NOC"
      filePrefix="noc-scorecard"
      caption={(from, to) =>
        `Ticket figures are live from Autotask for alert tickets created ${from} to ${to}; agent figures are live from ConnectWise Automate as of now.`
      }
    />
  );
}
